var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-view"},[_c('s-banner',{staticClass:"left"}),_c('s-details',{staticClass:"right"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }